/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TCreateTalentManagerEngagementRequest } from '../models/TCreateTalentManagerEngagementRequest';
import type { TEngagementCreditBalanceResponse } from '../models/TEngagementCreditBalanceResponse';
import type { TGetTalentManagerEngagementResponse } from '../models/TGetTalentManagerEngagementResponse';
import type { TListTalentManagerEngagementsResponse } from '../models/TListTalentManagerEngagementsResponse';
import type { TTalentManagerEngagementId } from '../models/TTalentManagerEngagementId';
import type { TUpdateTalentManagerEngagementRequest } from '../models/TUpdateTalentManagerEngagementRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TalentManagerEngagementService {
    /**
     * Create a new engagement between a group and a talent manager
     * @param requestBody
     * @returns TGetTalentManagerEngagementResponse Ok
     * @throws ApiError
     */
    public static createEngagement(
        requestBody: TCreateTalentManagerEngagementRequest,
    ): CancelablePromise<TGetTalentManagerEngagementResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/talent-manager-engagements',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List engagements for the authenticated TM
     * @returns TListTalentManagerEngagementsResponse Ok
     * @throws ApiError
     */
    public static listMyEngagements(): CancelablePromise<TListTalentManagerEngagementsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/talent-manager-engagements/my',
        });
    }
    /**
     * List engagements for the authenticated user's group
     * @returns TListTalentManagerEngagementsResponse Ok
     * @throws ApiError
     */
    public static listGroupEngagements(): CancelablePromise<TListTalentManagerEngagementsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/talent-manager-engagements/group',
        });
    }
    /**
     * Get a single engagement by ID
     * @param id
     * @returns TGetTalentManagerEngagementResponse Ok
     * @throws ApiError
     */
    public static getEngagement(
        id: TTalentManagerEngagementId,
    ): CancelablePromise<TGetTalentManagerEngagementResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/talent-manager-engagements/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update an engagement — currently used to grant/revoke the TM's `can_edit_project` permission.
     * Agency User (group member) or admin only.
     * @param id
     * @param requestBody
     * @returns TGetTalentManagerEngagementResponse Ok
     * @throws ApiError
     */
    public static updateEngagement(
        id: TTalentManagerEngagementId,
        requestBody: TUpdateTalentManagerEngagementRequest,
    ): CancelablePromise<TGetTalentManagerEngagementResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/talent-manager-engagements/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get credit balance for an engagement
     * @param id
     * @returns TEngagementCreditBalanceResponse Ok
     * @throws ApiError
     */
    public static getCreditBalance(
        id: TTalentManagerEngagementId,
    ): CancelablePromise<TEngagementCreditBalanceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/talent-manager-engagements/{id}/balance',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Complete an engagement
     * @param id
     * @returns TGetTalentManagerEngagementResponse Ok
     * @throws ApiError
     */
    public static completeEngagement(
        id: TTalentManagerEngagementId,
    ): CancelablePromise<TGetTalentManagerEngagementResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/talent-manager-engagements/{id}/complete',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Cancel an engagement
     * @param id
     * @returns TGetTalentManagerEngagementResponse Ok
     * @throws ApiError
     */
    public static cancelEngagement(
        id: TTalentManagerEngagementId,
    ): CancelablePromise<TGetTalentManagerEngagementResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/talent-manager-engagements/{id}/cancel',
            path: {
                'id': id,
            },
        });
    }
}
